import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Capacitor } from '@capacitor/core';

/**
 * Prevents the download page from being shown in the native Android app
 * (download is only for PWA users). Redirects to home when on Android.
 */
export const downloadPageGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    router.navigate(['/']);
    return false;
  }
  return true;
};
